import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Output,
} from '@angular/core';

@Component({
  selector: 'lib-removable-chip',
  templateUrl: './removable-chip.component.html',
  styleUrls: ['./removable-chip.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RemovableChipComponent {
  @Output()
  remove = new EventEmitter();

  onRemoveClick() {
    this.remove.emit();
  }
}
